module.exports = __webpack_public_path__ + "img/full.62795fdb.svg";